const topicItems = [
  { name: '暑期档必看', hot: true },
  { name: '悬疑推理', hot: true },
  { name: '古装仙侠', hot: true },
  { name: '都市情感', hot: false },
  { name: '科幻巨制', hot: true },
  { name: '甜宠偶像', hot: false },
  { name: '动作大片', hot: false },
  { name: '恐怖惊悚', hot: false },
  { name: '喜剧爆笑', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          发现全网最热影视话题，找到你的兴趣圈子
        </p>

        <div className="mt-8 md:mt-10 flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic, i) => (
            <div
              key={i}
              className={`relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium">{topic.name}</span>
              {topic.hot && (
                <span className="text-[10px] text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded font-bold whitespace-nowrap">
                  HOT
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3 md:gap-4">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            实时热议: 暑期档必看话题热度 9.8万
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            实时热议: 悬疑推理话题热度 7.2万
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            实时热议: 科幻巨制话题热度 5.6万
          </span>
        </div>
      </div>
    </section>
  );
}